import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { selectRestaurant } from '../../store/selectors/user.selector';
import { RETRIEVE_ALL_BOOKINGS } from "../../apollo/query/book.query";
import { Flex, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const Reservations = () => {
    /** Retrieve the restaurant ID */
    const restaurant = useSelector(selectRestaurant);
    /** Request the list of subcategories */
    const { data } = useQuery(RETRIEVE_ALL_BOOKINGS, { variables: { nIDRestaurant: restaurant?.nID } });
    const [expandedRowKeys, setExpandedRowKeys] = useState<any>([]);
    const [reservations, setReservations] = useState<any>([]);
    const [bookings, setBookings] = useState<any>([]);

    useEffect(() => {
        if( data?.data ) {
            const grouped = data.data?.reduce((acc: any, item: any) => {
                if (!acc[item.nID]) {
                    acc[item.nID] = [];
                }
                acc[item.nID].push(item);
                return acc;
            }, {});

            setReservations(grouped);
            setBookings(Object.values(grouped).map((x: any) => x[0]));
        }
    }, [data]);
    

    const columns = [
        {
            title: 'Data',
            dataIndex: 'dDate',
            key: 'dDate',
            render: (_: string, record: any) => (
                <Flex vertical justify="center" align="flex-start">
                    <span style={{ fontFamily: 'Roboto-Bold', fontSize: '0.75rem', textTransform: 'capitalize' }}>
                        { new Date(dayjs(record.dDate).format("YYYY-MM-DD")).toLocaleString('es-ES', { weekday:'long' }) }
                    </span>
                    <span style={{ fontFamily: 'Roboto-Bold', fontSize: '1.2rem' }}>
                        { dayjs(record.dDate).format("DD") }
                    </span>
                </Flex>
            )
        },
        {
            title: 'Nom de la reserva',
            dataIndex: 'sName',
            key: 'sName',
            render: (value: string, record: any) => (
                <Flex vertical gap={5}>
                    <span style={{ fontFamily: 'Roboto-Bold', fontSize: '1rem' }}> { value } </span>
                    <span style={{ fontFamily: 'Roboto-Light', fontSize: '0.75rem'}}> Telèfon: <span style={{ textDecoration: 'underline' }}> { record.sPhone } </span> </span>
                    <span style={{ fontFamily: 'Roboto-Light', fontSize: '0.75rem'}}> { record.nGuests } comensals </span>
                </Flex>
            )
        },
        {
            title: 'Description',
            dataIndex: 'sDescription',
            key: 'sDescription',
            render: (value: string) => <span style={{ maxWidth: 400, whiteSpace: 'pre-line', fontFamily: 'Roboto-Thin', fontSize: '0.8rem' }}> { value } </span>
        },
        {
            title: 'Estat',
            dataIndex: 'nStatus',
            key: 'nStatus',
            render: (value: number) => 
                <Tag color={ value === 0 ? 'default' : value === 1 ? 'green' : 'red'}>
                    { value === 0 ? 'A l\'espera' : value === 1 ? 'Reserva servida' : 'Reserva Cancel·lada'}
                </Tag>
        }
    ];

    const handleExpand = (expanded: any, record: any) => {
        setExpandedRowKeys(expanded ? [record.nID] : []);
    };

    return (
        <Flex vertical style={{ backgroundColor: 'white', height: '100%', padding: 10 }}>
            <Flex style={{ width: '100%' }}>
                <Table
                    columns={columns}
                    dataSource={bookings}
                    rowKey={(record: any) => record.nID}
                    style={{ width: '100%' }}
                    pagination={false}
                    expandable={{
                        expandedRowKeys,
                        onExpand: handleExpand,
                        expandedRowRender: (record) => {
                            const history = reservations[record.nID].filter((x: any) => x.sUser !== null && x.sUser !== "");

                            return (
                                <Flex vertical gap={10}>
                                    <ul>
                                        { history?.map((element: any) => (
                                            <li>
                                                <Flex key={element.dDateHistory} gap={5}>
                                                    <span> { element.sUser} </span> 
                                                    <span> ha </span> 
                                                    {/* eslint-disable-next-line eqeqeq */}
                                                    <span> { element.nStatusHistory == 1 ? 'modificat' : 'marcat com a cancel·lada' } </span> 
                                                    <span> la reserva al </span> 
                                                    <span> { element.dDateHistory } </span> 
                                                </Flex>
                                            </li>
                                        ))}
                                    </ul>
                                </Flex>
                            )
                        },
                    }}
                />
            </Flex>
        </Flex>
    );
}

export default Reservations